import { rem } from 'polished';
import styled from 'styled-components';

const CUSTOM_SWATCH_SIZE = 20;

const CustomSwatch = styled.button`
    border: 1px solid transparent;
    border-radius: ${rem(2)};
    box-shadow: ${({ theme }) => theme.base.boxShadow.elevationSmall};
    height: ${rem(CUSTOM_SWATCH_SIZE)};
    width: ${rem(CUSTOM_SWATCH_SIZE)};

    &,
    &:hover,
    &:focus,
    &:active {
        outline: 0;
    }
`;

export default CustomSwatch;
